import React, { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useUserData } from "components/customHooks/userDataContext";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from "react-router-dom";
import ShowPatientText from "components/modals/ShowPatientText";
import { BackButton } from "components/helpers";

//modals
import {
  getUserOrgDetails,
  updateTimesheetStatus,
  getTimesheetDetails,
} from "apiHandler/actions";

const TeamTimeSheet = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = useUserData();
  const [loading, setLoading] = useState(false);
  const [showText, setShowText] = useState(false);
  const [text, setText] = useState(null);
  const [timesheet_status, setTimesheet_status] = useState("");
  const [totalBreakHours, setTotalBreakHours] = useState("");
  const [totalNonbilableHours, setTotalNonbilableHours] = useState("");
  const [totalTotalHours, setTotalTotalHours] = useState("");
  const [totalWorkHours, setTotalWorkHours] = useState("");
  const [comment, setComment] = useState("");
  const [weekStartingDate, setWeekStartingDate] = useState(null);
  const [weekEndingDate, setWeekEndingDate] = useState(null);

  const [employeeSignature, setEmployeeSignature] = useState("");
  const [esDate, setEsDate] = useState(new Date());
  const [supervisorSignature, setSupervisorSignature] = useState("");
  const [supervisorComment, setSupervisorComment] = useState("");
  const [ssDate, setSsDate] = useState(new Date());
  const [datesList, setDatesList] = useState([]);

  const [employeeID, setEmployeeID] = useState("");
  const [employeeName, setEmployeeName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const timeSheetPayload = {
        user_id: userData?.email,
        timesheet_id: location.state.timesheet_id.toString(),
      };
      const timeSheetResponse = await getTimesheetDetails(timeSheetPayload);
      setTotalBreakHours(timeSheetResponse.total_break_hrs);
      setTotalNonbilableHours(timeSheetResponse.total_non_billable_hrs);
      setTotalTotalHours(timeSheetResponse.total_hrs);
      setTotalWorkHours(timeSheetResponse.total_work_hrs);

      setDatesList(
        timeSheetResponse.timesheet_dates_list.map((p) => ({
          ...p,
          id: p.id,
          timesheet_date: p.timesheet_date
            ? p.timesheet_date.slice(0, 16)
            : "Not available",
          break_hrs:
            p.break_hrs === null || p.break_hrs === 0
              ? "Not selected"
              : p.break_hrs,
          non_billable_hrs:
            p.non_billable_hrs === null || p.non_billable_hrs === 0
              ? "Not selected"
              : p.non_billable_hrs,
          notes:
            p.notes === null || p.notes === "" ? "No Comment added" : p.notes,
        }))
      );

      setWeekStartingDate(
        timeSheetResponse.week_start_date.slice(0, 16).replace(",", "")
      );
      setWeekEndingDate(
        timeSheetResponse.week_end_date.slice(0, 16).replace(",", "")
      );
      setEmployeeID(timeSheetResponse.user_id);
      setEmployeeName(timeSheetResponse.user_signature);
      setTimesheet_status(timeSheetResponse.status);
      setComment(timeSheetResponse.notes);
      setSupervisorComment(
        timeSheetResponse.supervisor_notes === null || ""
          ? ""
          : timeSheetResponse.supervisor_notes
      );
      setEmployeeSignature(
        timeSheetResponse.user_signature === null
          ? ""
          : timeSheetResponse.user_signature
      );
      setEsDate(
        timeSheetResponse.user_signature_date === null
          ? ""
          : new Date(timeSheetResponse.user_signature_date)
      );
      setLoading(false);
    };
    fetchData();
  }, []);

  const [supervisorName, setSupervisorName] = useState("");
  const [organizationName, setOrganizationName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        user_id: userData?.email,
      };
      const response = await getUserOrgDetails(payload);
      const data = response[0];
      setOrganizationName(data.org_name);
      setSupervisorName(
        data.supervisor_first_name + " " + data.supervisor_last_name
      );
      setSupervisorSignature(
        data.supervisor_first_name + " " + data.supervisor_last_name
      );
    };
    fetchData();
  }, []);

  const handleTimesheetFormSubmit = async (status_data) => {
    const payload = {
      user_id: userData?.email,
      timesheet_id: location.state.timesheet_id.toString(),
      status: status_data,
      supervisor_signature: supervisorSignature,
      supervisor_signature_date: ssDate,
      supervisor_notes: supervisorComment,
    };
    const response = await updateTimesheetStatus(payload);
    console.log(response);
    navigate("/timesheet");
  };

  const notesTextPopUp = (e) => {
    setText(e.row.notes);
    return (
      <p onClick={() => setShowText(true)} className="ceDOB">
        {<span>{e.row.notes}</span>}
      </p>
    );
  };

  const DataGridCustomFooterComponent = () => {
    return (
      <div>
        <span
          style={{ marginRight: "30px", fontWeight: "semibold" }}
        >{`Total Break Hours: ${totalBreakHours}`}</span>
        <span
          style={{ marginRight: "30px", fontWeight: "semibold" }}
        >{`Total Non-BilAble Hours: ${totalNonbilableHours}`}</span>
        <span
          style={{ marginRight: "30px", fontWeight: "semibold" }}
        >{`Total Hours: ${totalTotalHours}`}</span>
        <span
          style={{ marginRight: "100px", fontWeight: "semibold" }}
        >{`Total Work Hours: ${totalWorkHours}`}</span>
      </div>
    );
  };

  const columns = [
    {
      field: "timesheet_date",
      headerName: "Timesheet Date",
      minWidth: 165,
      flex: 1,
    },
    {
      field: "project_name",
      headerName: "Project Name",
      minWidth: 145,
      flex: 1,
    },
    {
      field: "task_name",
      headerName: "Task Name",
      minWidth: 145,
      flex: 1,
    },
    {
      field: "check_in_time",
      headerName: "Check-In Time",
      minWidth: 145,
      flex: 1,
    },
    {
      field: "check_out_time",
      headerName: "Check-Out Time",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "break_hrs",
      headerName: "Break Hours",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "total_hrs",
      headerName: "Total Hours",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "non_billable_hrs",
      headerName: "Non Billable Hours",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "work_hrs",
      headerName: "Work Hours",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "notes",
      headerName: "Notes",
      minWidth: 200,
      flex: 1,
      renderCell: notesTextPopUp,
    },
  ];

  return (
    <div className="check-patient-modal" style={{ margin: "auto" }}>
      <Grid container spacing={2}>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={6} md={12}>
            <BackButton onClick={() => navigate(-1)} />
          </Grid>
          <Grid container item spacing={1}>
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
              <p
                style={{
                  color: "#cb3366",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
              >{`Week of ${weekStartingDate}  To  ${weekEndingDate}`}</p>
            </Grid>
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Employee ID</span>
            <TextField
              disabled
              variant="standard"
              type="text"
              className="full-width"
              value={employeeID}
              onChange={(e) => setEmployeeID(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Employee Name</span>
            <TextField
              disabled
              variant="standard"
              type="text"
              className="full-width"
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Supervisor Name</span>
            <TextField
              disabled
              variant="standard"
              type="text"
              className="full-width"
              value={supervisorName}
              onChange={(e) => setSupervisorName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>Organization</span>
            <TextField
              disabled
              variant="standard"
              type="text"
              className="full-width"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4}>
            <span style={{ color: "#cb3366" }}>TimeSheet Status</span>
            <TextField
              disabled
              variant="standard"
              type="text"
              className="full-width"
              value={timesheet_status}
              onChange={(e) => setTimesheet_status(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container item>
          <Grid item xs={12} sm={12} md={12}>
            <DataGrid
              rows={loading ? [] : datesList}
              columns={columns}
              autoHeight
              disableSelectidisableRowSelectionOnClickonOnClick
              pagination
              pageSize={20}
              density="compact"
              slots={{
                pagination: DataGridCustomFooterComponent,
              }}
              loading={loading}
            />
          </Grid>
          <Grid container item spacing={1}>
            <Grid item xs={6} sm={6} md={12}>
              <span style={{ color: "#cb3366" }}>Comment</span>
              <TextField
                disabled
                variant="standard"
                type="text"
                className="full-width"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <span style={{ color: "#cb3366" }}>Employee Signature</span>
              <TextField
                disabled
                variant="standard"
                type="text"
                className="full-width"
                value={employeeSignature}
                onChange={(e) => setEmployeeSignature(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <span style={{ color: "#cb3366" }}>
                {esDate === "" ? "No Date Selected" : "Date"}
              </span>
              <KeyboardDatePicker
                disabled
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                value={esDate}
                onChange={(e) => setEsDate(e)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4}></Grid>
            <Grid item xs={6} sm={6} md={6}>
              <span style={{ color: "#cb3366" }}>Supervisor Signature</span>
              <TextField
                variant="standard"
                type="text"
                className="full-width"
                value={supervisorSignature}
                onChange={(e) => setSupervisorSignature(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={2}>
              <span style={{ color: "#cb3366" }}>
                {ssDate === "" ? "No Date Selected" : "Date"}
              </span>
              <KeyboardDatePicker
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                value={ssDate}
                onChange={(e) => setSsDate(e)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4}></Grid>
            <Grid item xs={12} sm={12} md={12}>
              <span style={{ color: "#cb3366" }}>Supervisor Note</span>
              <TextField
                required
                variant="outlined"
                type="text"
                className="full-width"
                value={supervisorComment}
                onChange={(e) => setSupervisorComment(e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div className="udm-btn-cont">
        <Button
          variant="contained"
          color="success"
          size="small"
          style={{
            marginTop: "10px",
          }}
          onClick={() => handleTimesheetFormSubmit("Approved")}
        >
          Approve
        </Button>
        <Button
          variant="outlined"
          color="error"
          size="small"
          style={{
            marginTop: "10px",
            marginLeft: "10px",
          }}
          onClick={() => handleTimesheetFormSubmit("Rejected")}
        >
          Reject
        </Button>
      </div>
      {showText && (
        <ShowPatientText text={text} onClose={() => setShowText(false)} />
      )}
    </div>
  );
};

export default TeamTimeSheet;
